import json from "@/messages.json";
import users from "@/users.json";
import ports from "@/ports.json";

export function scrollToTop(scrollDuration) {
  const scrollHeight = window.scrollY,
    scrollStep = Math.PI / (scrollDuration / 15),
    cosParameter = scrollHeight / 2;
  let scrollCount = 0,
    scrollMargin,
    scrollInterval = setInterval(function () {
      if (window.scrollY != 0) {
        scrollCount = scrollCount + 1;
        scrollMargin =
          cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
        window.scrollTo(0, scrollHeight - scrollMargin);
      } else clearInterval(scrollInterval);
    }, 15);
}

export function prevediSveOperacije(stringLok) {
  let pomStr = "";

  if (stringLok == "GRAPE_INPUT")
    pomStr = "Ulaz grožđa";
  else if (stringLok == "DECANTING")
    pomStr = "Pretakanje";
  else if (stringLok == "BLENDING")
    pomStr = "Kupažiranje";
  else if (stringLok == "MIXING")
    pomStr = "Mešanje";
  else if (stringLok == "FILTERING")
    pomStr = "Filtriranje";
  else if (stringLok == "FILLING")
    pomStr = "Dolivanje";
  else if (stringLok == "ADDING")
    pomStr = "Dodavanje";
  else if (stringLok == "MEASURING")
    pomStr = "Merenje";
  else if (stringLok == "BOTTLING")
    pomStr = "Flaširanje";
  else if (stringLok == "CHANGE_WINE")
    pomStr = "Promena vina";
  else if (stringLok == "CHANGE_PHASE")
    pomStr = "Promena faze";
  else if (stringLok == "PRESSING")
    pomStr = "Presovanje";
  else if (stringLok == "TRELLIS")
    pomStr = "Naslon";
  else if (stringLok == "EMPTYING")
    pomStr = "Istakanje";
  else if (stringLok == "WASHING")
    pomStr = "Pranje";
  else if (stringLok == "MACRO_OXYGENATION")
    pomStr = "Makro oksigenacija";
  else if (stringLok == "MICRO_OXYGENATION")
    pomStr = "Mikro oksigenacija";
  else
    pomStr = "BEZ PREVODA"

  return pomStr;
}

export function prevediSveOperacijeSaSrpskog(stringLok) {
  let pomStr = "";

  if (stringLok == "Ulaz grožđa")
    pomStr = "GRAPE_INPUT";
  else if (stringLok == "Pretakanje")
    pomStr = "DECANTING";
  else if (stringLok == "Kupažiranje")
    pomStr = "BLENDING";
  else if (stringLok == "Mešanje")
    pomStr = "MIXING";
  else if (stringLok == "Filtriranje")
    pomStr = "FILTERING";
  else if (stringLok == "Dolivanje")
    pomStr = "FILLING";
  else if (stringLok == "Dodavanje")
    pomStr = "ADDING";
  else if (stringLok == "Merenje")
    pomStr = "MEASURING";
  else if (stringLok == "Flaširanje")
    pomStr = "BOTTLING";
  else if (stringLok == "Promena vina")
    pomStr = "CHANGE_WINE";
  else if (stringLok == "Promena faze")
    pomStr = "CHANGE_PHASE";
  else if (stringLok == "Presovanje")
    pomStr = "PRESSING";
  else if (stringLok == "Naslon")
    pomStr = "TRELLIS";
  else if (stringLok == "Istakanje")
    pomStr = "EMPTYING";
  else if (stringLok == "Pranje")
    pomStr = "WASHING";
    else if (stringLok == "MACRO_OXIGENATION")
      pomStr = "Makro oksigenacija";
    else if (stringLok == "MICRO_OXIGENATION")
      pomStr = "Mikro oksigenacija";
  else
    pomStr = "BEZ PREVODA"

  return pomStr;
}

export function prevediOperacije(stringLok) {
  let pomStr = "";

  if (stringLok == "Dodavanje")
    pomStr = "ADDING";
  else if (stringLok == "Filtriranje")
    pomStr = "FILTERING";
  else if (stringLok == "Flaširanje")
    pomStr = "BOTTLING";
  else if (stringLok == "Vinograd" || stringLok == "Zasad")
    pomStr = "VINEYARD";
  else if (stringLok == "Pranje")
    pomStr = "WASHING";

  return pomStr;
}

export function prevediOperacije2(stringLok) {
  let pomStr = "";

  if (stringLok == "ADDING")
    pomStr = "Dodavanje";
  else if (stringLok == "FILTERING")
    pomStr = "Filtriranje";
  else if (stringLok == "BOTTLING")
    pomStr = "Flaširanje";
  else if (stringLok == "VINEYARD")
    localStorage.getItem("isWinery") === "true" ? pomStr = "Vinograd" : pomStr = "Zasad";
  else if (stringLok == "WASHING")
      pomStr = "Pranje";

  return pomStr;
}


export function prevediTipoveIzdavanja(stringLok) {
  let pomStr = "";

  if (stringLok == "GIFT")
    pomStr = "Poklon";
  else if (stringLok == "TASTING")
    pomStr = "Degustacija";
  else if (stringLok == "REPRESENTATION")
    pomStr = "Reprezentacija";
  else if (stringLok == "FAIR")
    pomStr = "Sajam";
  else
    pomStr = "Ostalo";

  return pomStr;
}

export function prevediOperacije3(stringLok) {
  let pomStr = "";

  if (stringLok == "MACHIN")
    pomStr = "Mašinska obrada";
  else if (stringLok == "HAND")
    pomStr = "Ručna obrada";
  else if (stringLok == "FITO")
    pomStr = "Zaštita";
  else if (stringLok == "TRELLIS")
    pomStr = "Naslon";
  else if (stringLok == "HARVEST")
    pomStr = "Berba";
  else if (stringLok == "PLANTING")
    pomStr = "Sadnja";
  else if (stringLok == "DESTROYING")
    pomStr = "Krčenje";
  else if (stringLok == "SELLING"){
    if(daLiJeVinarija(localStorage.getItem("isWinery")))
      pomStr = "Prodaja grožđa";
    else
      pomStr = "Prodaja ploda";
  }
  else if (stringLok == "PARAMETERS")
    pomStr = "Parametri";
  else if (stringLok == "STATE")
    pomStr = "Stanje";
  else if (stringLok == "PRUNING")
    pomStr = "Rezidba";
  else if (stringLok == "FERTILIZATION")
    pomStr = "Đubrenje";

  return pomStr;
}

export function prevediOperacije3SaSrpskog(stringLok) {
  let pomProdaja = "Prodaja ploda";
  if(daLiJeVinarija(localStorage.getItem("isWinery")))
    pomProdaja = "Prodaja grožđa";

  let pomStr = "";

  if (stringLok == "Mašinska obrada")
    pomStr = "MACHIN";
  else if (stringLok == "Ručna obrada")
    pomStr = "HAND";
  else if (stringLok == "Zaštita")
    pomStr = "FITO";
  else if (stringLok == "Naslon")
    pomStr = "TRELLIS";
  else if (stringLok == "Berba")
    pomStr = "HARVEST";
  else if (stringLok == "Sadnja")
    pomStr = "PLANTING";
  else if (stringLok == "Krčenje")
    pomStr = "DESTROYING";
  else if (stringLok == pomProdaja)
    pomStr = "SELLING";
  else if (stringLok == "Parametri")
    pomStr = "PARAMETERS";
  else if (stringLok == "Stanje")
    pomStr = "STATE";
  else if (stringLok == "Rezidba")
    pomStr = "PRUNING";
  else if (stringLok == "Đubrenje")
    pomStr = "FERTILIZATION";

  return pomStr;
}

export function prevediOperacijeSaSrpskog(stringLok) {
  let pomStr = "";

  if (stringLok == "Dodavanje")
    pomStr = "ADDING";
  else if (stringLok == "Filtriranje")
    pomStr = "FILTERING";
  else if (stringLok == "Flaširanje")
    pomStr = "BOTTLING";
  else if (stringLok == "Vinograd" || stringLok == "Zasad")
    pomStr = "VINEYARD";
  else if (stringLok == "Pranje")
    pomStr = "WASHING";

  return pomStr;
}

export function getDateTime() {
  const today = new Date();
  let Year = `${today.getFullYear()}`;
  let Month = `${today.getMonth() + 1}`;
  let Day = `${today.getDate()}`;

  let Minutes = `${today.getMinutes()}`;
  let Hours = `${today.getHours()}`;

  if (Month.length < 2) Month = `0${Month}`;
  if (Day.length < 2) Day = `0${Day}`;
  if (Hours.length < 2) Hours = `0${Hours}`;
  if (Minutes.length < 2) Minutes = `0${Minutes}`;

  return [Day, Month, Year].join(".") + " " + [Hours, Minutes].join(":");
}

export function getDateTimeNaslov() {
  const today = new Date();
  let Year = `${today.getFullYear()}`;
  let Month = `${today.getMonth() + 1}`;
  let Day = `${today.getDate()}`;

  let Minutes = `${today.getMinutes()}`;
  let Hours = `${today.getHours()}`;

  if (Month.length < 2) Month = `0${Month}`;
  if (Day.length < 2) Day = `0${Day}`;
  if (Hours.length < 2) Hours = `0${Hours}`;
  if (Minutes.length < 2) Minutes = `0${Minutes}`;

  return "na dan " + [Day, Month, Year].join(".") + " u " + [Hours, Minutes].join(":");
}

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export function currencyFormatDE(num) {
  return num
    .toFixed(2) // always two decimal digits
    .replace(".", ",") // replace decimal point character with ,
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
}

function formatDateTime(date) {
  let odgovor;

  try {
    let lokDate = date.split("T")[0];
    let lokTime = date.split("T")[1];

    let month = lokDate.split("-")[1];
    let day = lokDate.split("-")[2];
    const year = lokDate.split("-")[0];

    let HH = lokTime.split(":")[0];
    let mm = lokTime.split(":")[1];

    odgovor = [day, month, year].join(".") + " " + [HH, mm].join(":");
  } catch (error) {
    odgovor = "Greska u proceduri formatDateTime";
  }


  return odgovor;
}

export function readJSON(txtInput) {
  let strPom = "Nepoznata greška";


  if (typeof txtInput !== "undefined") {
    let strNiz = txtInput.split("$");
    let index = json.findIndex(x => x.value === strNiz[0]);
    //alert(index);

    if (json[index].value === "exception.warehouseInputOutput.input.exeedBottlingOnDate") {
      strPom = json[index].text.replace("{Vino}", formatDateTime(strNiz[1])).replace("{Lot}", strNiz[2]).replace("{Datum}", strNiz[3]).replace("{Primljrno}", strNiz[4]).replace("{Kolicina}", strNiz[5]).replace("{Flasirano}", strNiz[6]);
    }
    else if (json[index].value === "exception.operation.existsReverseDecantingOnSameDate") {
      strPom = json[index].text.replace("{Date}", formatDateTime(strNiz[1])).replace("{FromTank}", strNiz[2]).replace("{ToTank}", strNiz[3]);
    }
    else if (json[index].value === "exception.vineyardRow.delete.operationExecutedOnRow") {
      strPom = json[index].text.replace("{Datum}", formatDateTime(strNiz[3])).replace("{rowNumber}", strNiz[1]).replace("{Operacija}", strNiz[2]);
    }
    else if (json[index].value === "exception.vineyardRow.delete.destroyingOnRow") {
      strPom = json[index].text.replace("{Datum}", formatDateTime(strNiz[2])).replace("{rowNumber}", strNiz[1]);
    }
    else if (json[index].value === "exception.pouring.bottling.delete.cantBeUpdatedBecauseIsReceivedMore") {
      strPom = json[index].text.replace("{Datum}", formatDateTime(strNiz[1])).replace("{Primljrno}", strNiz[2]).replace("{Flasirano}", strNiz[3]);
    }
    else if (json[index].value === "exception.vineyardGrapeVarietyRow.delete.plantedPositionSegmentInUse") {
      strPom = json[index].text.replace("{rowNumber}", strNiz[1]).replace("{from}", strNiz[2]).replace("{to}", strNiz[3]).replace("{operation}", strNiz[3]).replace("{date}", formatDateTime(strNiz[4]));
    }
    else if (json[index].value === "exception.warehouseInputOutput.input.bottlingNotExist") {
      strPom = json[index].text.replace("{Vino}", strNiz[1]).replace("{Lot}", strNiz[2]).replace("{Datum}", formatDateTime(strNiz[3]));
    }
    else if (json[index].value === "exception.vineyardRow.rowNumberInBlockExist") {
      strPom = json[index].text.replace("{rowNumber}", strNiz[1]).replace("{block}", strNiz[2]);
    }
    else if (json[index].value === "exception.warehouseInputOutput.executeOutput.negativeStateAfterExecuting" ||
      json[index].value === "exception.warehouseInputOutput.updateExecuted.negativeState" ||
      json[index].value === "exception.warehouseInputOutput.cancel.negativeStateAfterCancelReceaiving" ||
      json[index].value === "exception.warehouseInputOutput.cancel.negativeStateAfterExecuting") {
      strPom = json[index].text.replace("{Artikal}", strNiz[1]).replace("{Lot}", strNiz[2]).replace("{Dokument}", strNiz[3]).replace("{Operacija}", prevediSveOperacije(strNiz[3])).replace("{Datum}", formatDateTime(strNiz[4]));
    }
    else if (json[index].value === "exception.warehouseInputOutput.updateExecutedOutput.notEnoughState" ||
      json[index].value === "exception.warehouseInputOutput.executeOutput.notEnoughState" ||
      json[index].value === "exception.warehouseInputOutput.updateDateOnExecutedDocument.notEnoughState" ||
      json[index].value === "exception.warehouseInputOutput.executeOutput.stateNotExist")
      strPom = json[index].text.replace("{Artikal}", strNiz[1]).replace("{Lot}", strNiz[2]).replace("{Datum}", formatDateTime(strNiz[3]));
    else if (json[index].value === "exception.pouring.bottling.update.cantBeUpdatedBecauseIsReceivedQuantityGreaterThenNew")
      strPom = json[index].text.replace("{Vino}", strNiz[1]).replace("{Lot}", strNiz[2]);
    else if (json[index].value === "exception.emptying.existsOperationAfterEmptyingDate")
      strPom = json[index].text.replace("{Operacija}", prevediSveOperacije(strNiz[1])).replace("{Datum}", formatDateTime(strNiz[2]));
    else if (strNiz.length === 3) {
      strPom = json[index].text.replace("{Tank}", strNiz[1]).replace("{Artikal}", strNiz[1]).replace("{Operacija}", prevediSveOperacije(strNiz[1])).replace("{Barik}", strNiz[1]).replace("{Datum}", formatDateTime(strNiz[2])).replace("{Sarza}", strNiz[2]).replace("{Vino}", strNiz[1]).replace("{Dokument}", strNiz[1]).replace("{Warehouse}", strNiz[2]).replace("{Label}", strNiz[1]).replace("{Year}", strNiz[2]).replace("{Row}", strNiz[1]).replace("{FromTo}", strNiz[2]);
    }
    else if (strNiz.length === 6) {
      strPom = json[index].text.replace("{Primljrno}", strNiz[1]).replace("{Kolicina}", strNiz[1]).replace("{Flasirano}", strNiz[2]).replace("{Vino}", strNiz[3]).replace("{Lot}", strNiz[4]);
    }
    else if (strNiz.length === 7) {
      strPom = json[index].text.replace("{Datum}", formatDateTime(strNiz[1])).replace("{Primljrno}", strNiz[2]).replace("{Kolicina}", strNiz[3]).replace("{Flasirano}", strNiz[4]).replace("{Vino}", strNiz[5]).replace("{Lot}", strNiz[6]);
    }
    else {
      if (strNiz.length === 1) {
        strPom = json[index].text;
      }
      else {
        if (json[index].text.indexOf("{Tank}") >= 0)
          strPom = json[index].text.replace("{Tank}", strNiz[1]);
        else if (json[index].text.indexOf("{Phase}") >= 0)
          strPom = json[index].text.replace("{Phase}", strNiz[1]);
        else if (json[index].text.indexOf("{Datum}") >= 0)
          strPom = json[index].text.replace("{Datum}", formatDateTime(strNiz[1]));
        else if (json[index].text.indexOf("{Warehouse}") >= 0)
          strPom = json[index].text.replace("{Warehouse}", strNiz[1]);
        else if (json[index].text.indexOf("{Vino}") >= 0)
          strPom = json[index].text.replace("{Vino}", strNiz[1]);
        else if (json[index].text.indexOf("{Dokument}") >= 0)
          strPom = json[index].text.replace("{Dokument}", strNiz[1]);
        else if (json[index].text.indexOf("{Etiketa}") >= 0)
          strPom = json[index].text.replace("{Etiketa}", strNiz[1]);
        else if (json[index].text.indexOf("{Quantity}") >= 0)
          strPom = json[index].text.replace("{Quantity}", strNiz[1]);
        else if (json[index].text.indexOf("{rowNumber}") >= 0)
          strPom = json[index].text.replace("{rowNumber}", strNiz[1]);
        else
          strPom = json[index].text;

      }
    }

    if (strPom.indexOf("INPUT") >= 0)
      strPom = strPom.replace("INPUT", "prijem");
    else if (strPom.indexOf("SELLING") >= 0)
      strPom = strPom.replace("SELLING", "prodaja");
    else if (strPom.indexOf("OUTPUT") >= 0)
      strPom = strPom.replace("OUTPUT", "izdavanje");
    else if (strPom.indexOf("WRITE_OFF") >= 0)
      strPom = strPom.replace("WRITE_OFF", "otpis");
  }

  return strPom;
}

export function findUser(txtUserName, txtPassword, txtPort) {
  // // console.log(users);
  let index = users.findIndex(x => x.userName === txtUserName && x.password === txtPassword);// && x.port === txtPort);

  if (index >= 0)
    return users[index].userName;
  else
    return "";
}

export function findToken(txtUserName) {
  // // // console.log(json);
  let index = users.findIndex(x => x.userName === txtUserName);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return users[index].token;
}
export function findWinery(txtUserName) {
  // // // console.log(json);
  let index = users.findIndex(x => x.userName === txtUserName);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return users[index].winery;
}

export function findCity(txtUserName) {
  // // // console.log(json);
  let index = users.findIndex(x => x.userName === txtUserName);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return users[index].city;
}

export function findRole(txtUserName) {
  // // // console.log(json);
  let index = users.findIndex(x => x.userName === txtUserName);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return users[index].role;
}

export function findIsWinery(txtUserName) {
  // // // console.log(json);
  let index = users.findIndex(x => x.userName === txtUserName);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return users[index].vinarija;
}

export function findPort(txtUrl) {
  // // // console.log(json);
  let index = ports.findIndex(x => x.url === txtUrl);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return ports[index].port;
}

export function findServiceLocation(txtUrl) {
  // // // console.log(json);
  let index = ports.findIndex(x => x.url === txtUrl);
  //alert(index);

  // // // console.log('readJSON ' + index)
  // // // console.log('readJSON ' + ports)

  return ports[index].urlRest;
}

export function findUser1(filter) {
  let lokBool = false;
  var usersLok = users;
  let user = usersLok.filter(function (item) {
    for (var key in filter) {


      if (item[key] === filter[key])
        lokBool = true;
    }
    // lokBool = true;
  });

  // // console.log(user)

  return lokBool;
}

export function scrollToTopBasNaVrh() {

  window.scrollTo(0, 0);
  return 2;
}

export function daLiJeVinarija(text) {
  let odgovor = false;

  let pomStr = localStorage.getItem("isWinery");

  if (pomStr === "true") {
    odgovor = true;
  }
  
  return odgovor;
}

export function nadjiSliku(id){

  let returnImageUrl = "../assets/iconsWine/wineImg.png?sig=" + +new Date();
  let vinarija = localStorage.getItem("vinarija");

  try { 
    // let images;

    // switch (vinarija) {
    //   case 'winedb':
    //     images = require.context("../statics/wineries/winedb/wineLabel/", false, /\.png$/)
    //     break;
    //   case 'sapat':
    //     images = require.context("../statics/wineries/sapat/wineLabel/", false, /\.png$/)
        
    //     break;
    //   case 'matalj':
    //     images = require.context("../statics/wineries/matalj/wineLabel/", false, /\.png$/)

    //     break;
    //   case 'aleksic':
    //       images = require.context("../statics/wineries/aleksic/wineLabel/", false, /\.png$/)
  
    //       break;
    // }

    
    // images("./" + id +".png")

    returnImageUrl = "../assets/wineries/" + vinarija + "/wineLabel/" + id +".png?sig=" + new Date();

  } catch (e) { 
    // alert(1234)
    console.log(e)
  }

  return returnImageUrl;
}

export function nadjiSlikuVina(id){

  let returnImageUrl = "../assets/iconsWine/wineImg.png?sig=" + +new Date();
  let vinarija = localStorage.getItem("vinarija");

  try { 
    // let images;

    // switch (vinarija) {
    //   case 'winedb':
    //     images = require.context("../assets/wineries/winedb/wine/", false, /\.png$/)
    //     break;
    //   case 'sapat':
    //     images = require.context("../assets/wineries/sapat/wine/", false, /\.png$/)
        
    //     break;
    //   case 'matalj':
    //     images = require.context("../assets/wineries/matalj/wine/", false, /\.png$/)

    //     break;
    //   case 'aleksic':
    //     images = require.context("../assets/wineries/aleksic/wine/", false, /\.png$/)

    //     break;
    // }

    
    // images("./" + id +".png")

    returnImageUrl = "../assets/wineries/" + vinarija + "/wine/" + id +".png?sig=" + +new Date();

  } catch (e) { 
    
  }

  return returnImageUrl;
}